<template>
  <div class="app-view-layout">
    <v-toolbar
      class="app-view-layout__toolbar"
      flat
      height="100"
    >
      <div>
        <h2 class="app-view-layout__header">
          {{ header }}
        </h2>

        <p
          v-if="subheader"
          class="app-view-layout__count"
        >
          {{ subheader }}
        </p>

        <p
          v-if="itemsCount"
          class="app-view-layout__count"
        >
          {{ projectsCountSuffix }}
        </p>
      </div>

      <v-spacer />

      <slot name="toolbarMenu" />
    </v-toolbar>

    <div
      class="app-view-layout__content"
      :class="[
        {'mt-1' : fluid},
        {'pa-8' : fluid && !noPadding},
        {'pa-0': noPadding}
      ]"
    >
      <slot
        v-if="fluid"
        name="content"
      />

      <v-container v-else>
        <slot name="content" />
      </v-container>
    </div>
  </div>
</template>

<script>
import utils from '@/helpers/utils';

export default {
  props: {
    header: {
      type: String,
      required: true,
    },
    subheader: {
      type: String,
      default: '',
    },
    itemsCount: {
      type: Number,
      default: null,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    projectsCountSuffix() {
      return utils.getCounterWithSuffix(this.itemsCount, 'rezultat', 'rezultaty', 'rezultatów');
    },
  },
};
</script>

<style lang="scss" scoped>
.app-view-layout {
  &__header {
    font-size:20px;
    margin-bottom:4px;
    font-weight:700;
    min-width: 200px;
  }
  &__count {
    font-size:12px;
    letter-spacing:.5px;
  }
  &__toolbar {
    justify-content: space-between;
    padding-right: 20px;
    padding-left: 20px;
  }
  &__content {
    padding: 0 20px;
  }
}
</style>
